// extracted by css-extract-rspack-plugin
export default {"content":"V7e2v9nKEhASVUEn__content___","title":"KWXuze2hEUOpuHmB__title___"};